import config from '@project/config';

const recaptchaBaseUrl = `${config.hostUrl}/api/recaptcha/v1/verifications`;

export default {
  getVerficationUrl: () => `${recaptchaBaseUrl}/verify`,
};
